import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useAuthState } from "../../../MainComponents/GlobalContext";
import useAxios from "../../../MainComponents/Hooks/useAxios";
import HelmetTags from "../../../MainComponents/HelmetTags";
import VideoCard from "../../../MainComponents/VideoCard";
import { Loader } from "../../../MainComponents";
import StudentMaterials from "./StudentMaterials";

const StudentPastPaperFitleration = ({ section }) => {
  const [showVideo, setShowVideo] = useState({
    show: false,
    src: "",
  });
  const [activeMaterialType, setActiveMaterialType] = useState("pdfs");

  const api = `${process.env.REACT_APP_STUDENT_ALL_MATRIALES_PAST_PAPER_API}/${section}`;

  //!---- get all Matrials -------
  const [GetMatrialsSuccess, GetMatrialsErrors, GetMatrialsLoading] = useAxios(
    api,
    "GET",
    section,
    section,
  );

  const filteredData = GetMatrialsSuccess?.data?.filter((card) => {
    return card;
  });
  const visibleMaterials = filteredData?.filter(
    (item) => item?.type === activeMaterialType,
  );

  return (
    <section className="h-auto w-full overflow-y-auto px-20 py-20 dark:bg-dark dark:text-light sm:px-10">
      <HelmetTags
        title={`${section.toUpperCase()} Matrials | Nash Academy`}
      ></HelmetTags>

      {showVideo.show && (
        <div
          onClick={() => setShowVideo((prev) => ({ ...prev, show: false }))}
          className={`fixed inset-0 z-50 flex h-screen w-full origin-bottom items-center justify-center bg-blue-200/40 transition-all duration-300 ease-in-out ${
            showVideo.show === true
              ? "opacity- pointer-events-auto scale-100"
              : "opacity- pointer-events-none scale-0 hidden"
          } `}
        >
          <div className="iframe-wrapper aspect-video w-3/4 overflow-hidden rounded-3xl border-0 border-secondary">
            <div
              className="flex items-center justify-center h-full"
              dangerouslySetInnerHTML={{
                __html: showVideo.src,
              }}
            />
          </div>
        </div>
      )}

      <div className="mb-20 flex flex-col items-start gap-20">
        <div className="top-btns flex w-full justify-start gap-5 asm:flex-col asm:items-center ">
          <div className="w-1/2 md:w-full">
            <div
              className={` service-card  md:w-full shadow-xl cursor-pointer snap-start shrink-0 py-8 px-6 flex flex-col items-start gap-3 transition-all duration-300 group ${
                activeMaterialType === "pdfs"
                  ? "bg-secondary text-white"
                  : "bg-white hover:bg-secondary hover:text-white"
              }`}
              onClick={() => setActiveMaterialType("pdfs")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setActiveMaterialType("pdfs");
                }
              }}
            >
              <p
                className={`font-bold text-3xl group-hover:text-white ${
                  activeMaterialType === "pdfs" ? "text-white" : "text-secondary"
                }`}
              >
                Pdfs
              </p>
            </div>
          </div>

          <div className="w-1/2 md:w-full">
            <div
              className={` service-card  md:w-full shadow-xl cursor-pointer snap-start shrink-0 py-8 px-6 flex flex-col items-start gap-3 transition-all duration-300 group ${
                activeMaterialType === "exam"
                  ? "bg-secondary text-white"
                  : "bg-white hover:bg-secondary hover:text-white"
              }`}
              onClick={() => setActiveMaterialType("exam")}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setActiveMaterialType("exam");
                }
              }}
            >
              <p
                className={`font-bold text-3xl group-hover:text-white ${
                  activeMaterialType === "exam" ? "text-white" : "text-secondary"
                }`}
              >
                Exams
              </p>
            </div>
          </div>
        </div>

        {GetMatrialsLoading && (
          <div className="w-full">
            <Loader />
          </div>
        )}
        {GetMatrialsErrors && (
          <p className="text-bolder text-center w-full">{GetMatrialsErrors}</p>
        )}
        <div className="videos video-grid-auto-fit w-full ">
          {visibleMaterials?.length === 0 ? (
            <p>Threre is no matrials</p>
          ) : (
            visibleMaterials?.map((video) => (
              <VideoCard
                setShowVideo={setShowVideo}
                video={video}
                key={video.key}
                type={section}
              />
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default StudentPastPaperFitleration;
